var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCandidateResume(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 0.666504C1.61929 0.666504 0.5 1.78579 0.5 3.1665V14.8332C0.5 16.2139 1.61929 17.3332 3 17.3332H13C14.3807 17.3332 15.5 16.2139 15.5 14.8332V5.45204C15.5 4.789 15.2366 4.15311 14.7678 3.68427L12.4822 1.39874C12.0134 0.929896 11.3775 0.666504 10.7145 0.666504H3ZM10.5 2.50576V3.99983C10.5 4.92031 11.2462 5.6665 12.1667 5.6665H13.6607C14.032 5.6665 14.2179 5.21769 13.9554 4.95521L11.2113 2.21113C10.9488 1.94864 10.5 2.13455 10.5 2.50576ZM3.83333 8.1665C3.83333 7.70627 4.20643 7.33317 4.66667 7.33317H11.3333C11.7936 7.33317 12.1667 7.70627 12.1667 8.1665C12.1667 8.62674 11.7936 8.99984 11.3333 8.99984H4.66667C4.20643 8.99984 3.83333 8.62674 3.83333 8.1665ZM4.66667 10.6665C4.20643 10.6665 3.83333 11.0396 3.83333 11.4998C3.83333 11.9601 4.20643 12.3332 4.66667 12.3332H8C8.46024 12.3332 8.83333 11.9601 8.83333 11.4998C8.83333 11.0396 8.46024 10.6665 8 10.6665H4.66667Z",
    fill: "#CCCCCC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCandidateResume);
export default __webpack_public_path__ + "static/media/candidate-resume.1d395e944e9e71d4f2c9a81f899a8a24.svg";
export { ForwardRef as ReactComponent };